/**
 * 创建人：D
 * 创建时间：2019-07-12
 * 描述：tab标签页方法
 * 更新记录: 
 */

import { Injectable, ComponentRef } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { SwSimpleReuseStrategy } from '../sw-simplereusestrategy';
import { SwJwtService } from '../sw-jwt.service';
import { Router } from '@angular/router';
import { SwRouteguardService } from '../sw-routeguard.service';
import { environment } from 'src/environments/environment';
import { SwHttpClientService } from '../sw-http-client.service';
import { SystemIdService } from './system-id.service';


/**
 * tab页公共服务
 */
@Injectable()
export class SwTabService {
  /**
   * @ignore
   */
  constructor(
    private location: PlatformLocation, 
    private jwt: SwJwtService,
    private router: Router, 
    private rot: SwRouteguardService,
    private http:SwHttpClientService,
    private systemIdService:SystemIdService,
    ) {
  }

  /**
   * @ignore
   */
  private menuList: any;

  /**
   * 刷新指定uri，不输入则默认刷新当前页面，只能刷新在路由复用缓存中存在的页面，单页签下此方法无效
   * @param path  刷新路由地址
   */
  refurbis(path?: string) {
    //获取tab菜单
    this.menuList = this.rot.getMenus();
    var router: any = {};
    //拿到当前uri
    if (path != null && path != "" && path != undefined) {
      //若有参数则为参数指定
      router.path = path;
    } else {
      router.path = this.getPathname();
    }
    //如果tab页有此页面存在，那就跳转到该页面 （单页签模式下 index=-1）
    let index = this.menuList.findIndex(v=>v.path == router.path)
    // console.log('调用了 refurbis 方法，参数-path：',path,'索引-',index);
    if(index != -1){
      setTimeout(() => {
        SwSimpleReuseStrategy.deleteRouteSnapshot(router.path)
        this.menuList.forEach(item => {
          if (item.path == router.path) {
            item.isSelect = true
            //如果显示标签就是事件源标签,直接刷新没有作用,就统一先跳转到别的路由再跳转到事件源标签的路由
            this.router.navigateByUrl('').then(() => {
              this.router.navigate([item.path], {
                queryParams: item.queryParams
              })
            })
          } else {
            item.isSelect = false
          }
        })
      }, 10);

    } 
  }
  /**
   * 关闭选项标签 如果不传递参数 默认关闭当前
   * @param path 关闭路由地址 
   * @param isSelect  关闭的tab 是否选中
   * @param toUri  单页签模式下，由于该服务的其他跳转/刷新方法都失效了，所以此参数决定关闭之后要跳转的路由
   */
  closeUrl(path?: string, isSelect?: boolean,toUri?:string) {
    // console.log('调用了 closeUrl 方法，参数-path：',path,'参数-toRouter：',toRouter);
    this.menuList = this.rot.getMenus();
    let url = this.getPathname();
    //如果不传递参数 默认关闭当前
    if (path)
      url = path;
    else
      isSelect = true;

      
    if(environment.singleTab){
      //如果是单页签
      // console.log('单页签下调用关闭方法');
      this.closeOrRefresh(url,toUri)
      
    } else {
      // console.log('多页签下调用关闭方法');
      let index = this.menuList.findIndex(p => p.path.toLowerCase() == url.toLowerCase());
      //如果只有一个不可以关闭,还有单页签时也不用关闭
      if (this.menuList.length == 1) {
        return;
      }
  
      let deletMenuList = this.menuList.filter(p => p.path.toLowerCase() == url.toLowerCase());
      if (deletMenuList.length > 0)
      setTimeout(() => {
        SwSimpleReuseStrategy.deleteRouteSnapshot(deletMenuList[0].path)
      }, 0);     //删除复用
      this.menuList = this.menuList.filter(p => p.path.toLowerCase() != url.toLowerCase());
      if (!isSelect) {
        this.rot.valueUpdated.next(this.menuList)
        this.rot.setMenu(this.menuList);
        //this.jwt.setToKen("TabMenu", JSON.stringify(this.menuList));
        return
      }
      //显示下一个选中
      let menu = this.menuList[index];
      if (!menu) {//如果下一个没有上一个选中
        menu = this.menuList[index - 1];
      }
      this.menuList.forEach(p => p.isSelect = p.path.toLowerCase() == menu.path.toLowerCase());
      //显示当前路由信息
      this.router.navigate(['/' + menu.path], { queryParams: menu.queryParams });
      this.rot.valueUpdated.next(this.menuList)
      this.rot.setMenu(this.menuList);
      //this.jwt.setToKen("TabMenu", JSON.stringify(this.menuList));

    }
  }

  /**
   * 跳转到指定路由,只能跳转到已存在的页面，单页签下该方法无效
   * @param Path  路由地址
   */
  gotoUrl(path: string) {
    //获取到当前所有的tab页
    this.menuList = this.rot.getMenus();
    //查看输入的路由 有没有数据 （单页签模式下，index=0就是刷新当前页， index=-1 就什么都不做）
    let index = this.menuList.findIndex(p => p.path.toLowerCase() == path.toLowerCase());
    // console.log('调用了 gotoUrl 方法，参数-path：',path,'索引-',index);
    if (index >= 0) {
      //跳转到tab页面
      this.router.navigate([this.menuList[index].path], {
        queryParams: this.menuList[index].queryParams
      });
    }
  }

  /**
   * 获取当前路由地址 
   * @ignore
   */
  getPathname() {
    //获取当前路由地址 进行转换
    let pathname = ""
    try {
      //获取地址栏中的路由, 渠道 ? 后面的字符串, 并将之以 '/' 符号分割为数组
      let path = this.location["location"].hash.split('?')[0].split("/");
      for (let i = 0; i < path.length; i++) {
        if (i > 0) {
          pathname = pathname + "/" + path[i]
        }
      }
    } catch (e) {
    }
    return pathname;
  }

  /**
   * 调用某个页面中的特定的方法,实现局部刷新; 只有在路由缓存中的页面有效，单页签下此方法无效
   * @param Path  路由地址
   * @param method  该路由对应组件中的方法名
   * 使用方法:  this.swTab.refreshPart('oa/ToDoProcess');
   * 使用情景: 在新增/修改 的tab 页操作完成之后,需要关闭当前 tab 页, 刷新主页面的部分数据 , 最后跳转到主页面;
   * 例如:  this.swTab.closeUrl(this.routerMenu.path, this.routerMenu.isSelect)  //关闭该页面的路由菜单
   *        this.swTab.refreshPart('/bdp/TableDesign','getTables')  //调用主页面的 getTables 方法 , 实现局部刷新
   *        this.swTab.gotoUrl('/bdp/TableDesign')  //跳转到主页面
   * @ignore
   */
  refreshPart(path:string,method:string){
    // console.log('调用了 refreshPart 方法，参数-path：',path);
    //将传进来的路由中的 / 替换为 _
    path = path.replace(/\//g,'_');
    //获取路由缓存
    let routerCache  = SwSimpleReuseStrategy.getRouterCache()
    //如果传进来的路由是 /oa/ToDoProcess 这种类型, 那么现在就变成了 _oa_ToDoProcess
    if(path[0] == '_'){ 
      //如果路径是由 _ 开头的, 就将开头的 _ 去掉
      path = path.substr(1)
    }
    //遍历路由缓存的 Map （单页签模式下不会有路由缓存）
    routerCache.forEach((v,k)=>{
      //如果含有此路由缓存
      if(k.indexOf(path) >= 0){
        // console.log('执行了 refreshPart 方法');
        
        //获取对应路由的组件
        let handle = routerCache.get(k).handle as { componentRef: ComponentRef<any> };
        let con = handle.componentRef["_component"]
        //遍历该组件内部的变量和方法
        for (const m in con) {
          if (m == method) {
            //如果该组件内部存在传入的方法
            handle.componentRef["_component"][method]()  //调用该组件中的特定的方法
          }
        }
      }
    })
  }

  /**
   * 单页签模式下，关闭某个页面，并跳转到另一个页面
   * @param closeUrl 关闭tab页，closeUrl 为页面路径；
   * @param toUrl 跳转到某个tab页;
   */
  closeOrRefresh(closeUrl:string,toUrl:string){
    this.menuList = this.rot.getMenus();
    let url = closeUrl
    let index = this.menuList.findIndex(p => p.path.toLowerCase() == url.toLowerCase());  //找到要关闭的菜单索引
    let defaultToUrl = this.menuList[index]['preTab']
    // console.log('默认可以跳转的页面',defaultToUrl);
    // console.log('指定要跳转的页面',toUrl);
    if(toUrl){
      //如果有要跳转的路径
      let systemId = this.systemIdService.getSystemId()
      //根据路径去获取菜单名称
      this.http.Post(environment.seekerWebAPI+'function/queryMenuInfoByUri?uri='+toUrl+'&systemId='+systemId,{}).subscribe(r=>{
        if(r && r.code == 200){
          let functionName = r.data.functionName
          //直接进行跳转，单页签下跳转都是刷新，跳转之后会触发路由守卫，其中会自动调整 menuList 数量
          this.router.navigate([toUrl], { queryParams:{Title:functionName} });
        }
      })
    } else if(defaultToUrl){
      //直接进行跳转，单页签下跳转都是刷新，跳转之后会触发路由守卫，其中会自动调整 menuList 数量
      this.router.navigate([defaultToUrl['path']], { queryParams:defaultToUrl['queryParams'] });
    } else {
      //既没有指定跳转路由，也没有默认跳转路由，就跳转到首页
      this.router.navigate([environment.defaultPortal], { queryParams:{Title:'控制台'} });

    }

  }
}
